'use client';
import { cn } from '~/lib/utils';
import { motion, useMotionTemplate, useMotionValue } from 'framer-motion';
import React, { useState } from 'react';

export const HoverCard = ({
  className,
  children,
  radius = 250,
}: {
  className?: string;
  children: React.ReactNode;
  radius?: number;
}) => {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  function handleMouseMove({ currentTarget, clientX, clientY }: any) {
    const { left, top } = currentTarget.getBoundingClientRect();

    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  }
  const [visible, setVisible] = useState(false);
  return (
    <motion.div
      style={{
        background: useMotionTemplate`
        radial-gradient(
          ${visible ? `${radius}px` : '0px'} circle at ${mouseX}px ${mouseY}px,
          var(--background),
          transparent 80%
        )
      `,
      }}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      className={cn('rounded-[25px] p-[2px] transition duration-300', className)}
    >
      {children}
    </motion.div>
  );
};
